// Config
import { DEFAULT_ROUTE_NAME } from '~/config';

export default defineNuxtRouteMiddleware(() => navigateTo({ name: DEFAULT_ROUTE_NAME }));
